// project import
import admin, { settings } from './admin';
import dashboard from './dashboard';
import instructor from './instructor';

// ==============================|| MENU ITEMS ||============================== //

export function getMenuItems(role) {
  if (role === 'admin') return { items: [admin, settings] };
  if (role === 'instructor') return { items: [instructor] };
  return { items: [dashboard] };
}
